<template>
  <div>
    <div v-if="type === 'date'">
      {{value | moment("DD-MM-YYYY")}}
    </div>
    <div v-else-if="type === 'datetime'">
      {{value | moment("utc","DD-MM-YYYY hh:mm")}}
    </div>
    <div v-else-if="type === 'year'">
      {{value }}
    </div>
    <div v-else-if="type === 'month-year'">
      {{value | moment("MM-YYYY")}}
    </div>
    <div v-else-if="type === 'time'">
      {{value | moment("hh:mm")}}
    </div>
    <div v-else-if="type === 'number'">
      {{value | numberFormat}}
    </div>
    <div v-else-if="type === 'money'">
      $ {{value | numberFormat}}
    </div>
    <div v-else>
      {{value}}
    </div>
  </div>
</template>

<script>
  export default {
    name: "filter-data",
    props: {
      value: {default: null},
      type: {type: String, default: ''}
    }
  }
</script>

<style scoped>

</style>
